export const IF_LABEL: string = 'If'
export const ELSE_HANDLE_ID: string = 'ELSE'
export const ELSE_HANDLE_LABEL: string = 'Else'

export const getDefaultBranchLabel = (index: number): string =>
  `Branch ${index + 1}`
